(function () {

    'use strict';

    /*
     * GLOBAL ANGULAR CONFIGURATION
     */

    angular.module('ShargoApp')

        .config(function ($routeProvider, $locationProvider, $mdDateLocaleProvider, $httpProvider, saRouterProvider) {

            $locationProvider.html5Mode(true);
                saRouterProvider.
				when({
					'es': '/es/clients',
					'ca': '/ca/clients',
					'en': '/clients'
				}, {
					name: 'clients-page',
					templateUrl: 'templates/clients/clients-page.html',
					controller: 'ClientsPageController',
					isPublic: true,
					title: 'seo.title.clients-page',
					description: 'seo.description.clients-page',
					robots: 'Index, Follow',
					canonical: 'seo.canonical.clients-page',
					alternate: 'seo.alternate.clients-page'
				}).
				when({
					'es': '/es/promo/:code',
					'ca': '/ca/promo/:code',
					'en': '/promo/:code'
				}, {
					name: 'mgm-register',
					templateUrl: 'templates/mgm/mgm-register.html',
					controller: 'MGMRegisterController',
					isPublic: true,
					title: 'seo.title.mgm-register',
					description: 'seo.description.mgm-register',
					robots: 'Index, NoFollow',
					canonical: 'seo.canonical.mgm-register',
					alternate: 'seo.alternate.mgm-register',
					extra: 'code'
				}).
                when({
                        'es': '/es/pro',
                        'ca': '/ca/pro',
                        'en': '/pro'
                    }, {
                    name: 'shargopro-page',
                    shargoPro: true,
                    templateUrl: 'templates/static/shargopro-page.html',
                    controller: 'ShargoProPageController',
                    title: 'seo.title.shargopro-page',
                    description: 'seo.description.shargopro-page',
                    robots: 'Index, Follow',
                    canonical: 'seo.canonical.shargopro-page',
                    alternate: 'seo.alternate.shargopro-page'
                }).
                when({
                    'es': '/es/contacta-con-shargopro',
                    'ca': '/ca/contacta-amb-shargopro',
                    'en': '/contact-with-shargopro'
                }, {
                    name: 'enterprise-contact-pro',
                    shargoPro: true,
                    templateUrl: 'templates/static/enterprise-contact.html',
                    controller: 'EnterpriseContactController',
                    title: 'seo.title.enterprise-contact-pro',
                    description: 'seo.description.enterprise-contact-pro',
                    robots: 'Index, Follow',
                    canonical: 'seo.canonical.enterprise-contact-pro',
                    alternate: 'seo.alternate.enterprise-contact-pro'
                }).
                when({
                    'es': '/es/contacta-con-shargo',
                    'ca': '/ca/contacta-amb-shargo',
                    'en': '/contact-with-shargo'
                }, {
                    name: 'enterprise-contact',
                    templateUrl: 'templates/static/enterprise-contact.html',
                    controller: 'EnterpriseContactController',
                    title: 'seo.title.enterprise-contact',
                    description: 'seo.description.enterprise-contact',
                    robots: 'Index, Follow',
                    canonical: 'seo.canonical.enterprise-contact',
                    alternate: 'seo.alternate.enterprise-contact'
                }).
                when({
                    'es': '/es/perfil-shargo',
                    'ca': '/ca/perfil-shargo',
                    'en': '/profile-shargo'
                }, {
                    name: 'driver-profile',
                    templateUrl: 'templates/static/driver-profile.html',
                    controller: 'DriverProfileController',
                    title: "seo.title.profile-shargo",
                    description: "seo.description.profile-shargo",
                    robots: "Index, Follow",
                    canonical: "seo.canonical.profile-shargo",
                    alternate: "seo.alternate.profile-shargo"
                }).
                when({
                    'es': '/es/prensa',
                    'ca': '/ca/prensa',
                    'en': '/press'
                }, {
                    name: 'press',
                    templateUrl: 'templates/static/press.html',
                    controller: 'PressController',
                    title: "seo.title.press",
                    description: "seo.description.press",
                    robots: "Index, Follow",
                    canonical: "seo.canonical.press",
                    alternate: "seo.alternate.press"
                }).
                when({
                    'es': '/es/equipo',
                    'ca': '/ca/equip',
                    'en': '/team'
                }, {
                    name: 'about-us',
                    templateUrl: 'templates/static/about-us.html',
                    controller: 'AboutUsController',
                    title: "seo.title.about-us",
                    description: "seo.description.about-us",
                    robots: "Index, Follow",
                    canonical: "seo.canonical.about-us",
                    alternate: "seo.alternate.about-us",
                    css: "about-us"
                }).
                when({
                    'es': '/es/conduce-con-shargo',
                    'ca': '/ca/condueix-amb-shargo',
                    'en': '/drive-with-shargo'
                }, {
                    name: 'driver-page',
                    templateUrl: 'templates/static/driver-page.html',
                    controller: 'DriverPageController',
                    title: "seo.title.driver-page",
                    description: "seo.description.driver-page",
                    robots: "Index, Follow",
                    canonical: "seo.canonical.driver-page",
                    alternate: "seo.alternate.driver-page",
                    css: "driver-page"
                }).
                when({
                    'es': '/es/apuntate',
                    'ca': '/ca/apuntat',
                    'en': '/sign-up'
                }, {
                    name: 'driver-form',
                    templateUrl: 'templates/static/driver-form.html',
                    controller: 'DriverFormController',
                    title: "seo.title.drive-with-shargo",
                    description: "seo.description.drive-with-shargo",
                    robots: "Index, NoFollow",
                    canonical: "seo.canonical.drive-with-shargo",
                    alternate: "seo.alternate.drive-with-shargo"
                }).
                when({
                    'es': '/es/ultimos-pasos/:token',
                    'ca': '/ca/ultims-pasos/:token',
                    'en': '/last-steps/:token'
                }, {
                    name: 'driver-register',
                    templateUrl: 'templates/static/driver-register.html',
                    controller: 'DriverRegisterController',
                    title: "seo.title.last-steps",
                    description: "seo.description.last-steps",
                    robots: "NoIndex, NoFollow",
					canonical: "seo.canonical.last-steps",
					alternate: "seo.alternate.last-steps",
					extra: "token"
                }).
                when({
                    'es': '/es/perfil',
                    'ca': '/ca/perfil',
                    'en': '/profile'
				}, {
                    name: 'profile',
                    templateUrl: 'templates/profile.html',
                    controller: 'ProfileController',
                    isPublic: false,
                    title: "seo.title.profile",
                    description: "seo.description.profile",
                    robots: "Index, Follow",
					canonical: "seo.canonical.profile",
					alternate: "seo.alternate.profile"
                }).
                when({
                    'es': '/es/contactanos',
                    'ca': '/ca/contactans',
                    'en': '/contact-us'
                }, {
                    name: 'contact',
                    templateUrl: 'templates/contact.html',
                    controller: 'ContactController',
                    title: "seo.title.contact-us",
                    description: "seo.description.contact-us",
                    robots: "Index, NoFollow",
					canonical: "seo.canonical.contact-us",
					alternate: "seo.alternate.contact-us"
                }).
                when({
                    'es': '/es/pedir-un-shargo',
                    'ca': '/ca/demanar-un-shargo',
                    'en': '/order-a-shargo'
                }, {
                    name: 'sendpackage',
                    templateUrl: 'templates/send-package.html',
                    controller: 'SendPackageController',
                    title: "seo.title.order-a-shargo",
                    description: "seo.description.order-a-shargo",
                    robots: "Index, Follow",
					canonical: "seo.canonical.order-a-shargo",
					alternate: "seo.alternate.order-a-shargo"
                }).
                when({
                    'es': '/es/pedidos',
                    'ca': '/ca/comandes',
                    'en': '/dashboard'
                }, {
                    name: 'dashboard',
                    templateUrl: 'templates/dashboard.html',
                    isPublic: false,
                    title: "seo.title.dashboard",
                    description: "seo.description.dashboard",
                    robots: "Index, Follow",
					canonical: "seo.canonical.dashboard",
					alternate: "seo.alternate.dashboard"
                }).
                when({
                    'es': '/es/terminos-y-condiciones',
                    'ca': '/ca/termes-i-condicions',
                    'en': '/legal-terms'
                }, {
                    name: 'termsconditions',
                    templateUrl: 'templates/static/terms-privacy.html',
                    title: "seo.title.legal-terms",
                    description: "seo.description.legal-terms",
                    robots: "NoIndex, NoFollow",
					canonical: "seo.canonical.legal-terms",
					alternate: "seo.alternate.legal-terms"
                }).
                when({
                    'es': '/es/terminos',
                    'ca': '/ca/termes',
                    'en': '/terms'
                }, {
                    name: 'terms',
                    templateUrl: 'templates/static/terms.html',
                    title: "seo.title.terms",
                    description: "seo.description.terms",
                    robots: "NoIndex, NoFollow",
					canonical: "seo.canonical.terms",
					alternate: "seo.alternate.terms"
                }).
                when({
                    'es': '/es/politica-de-privacidad',
                    'ca': '/ca/politica-de-privacitat',
                    'en': '/privacy-policy'
                }, {
                    name: 'privacy',
                    templateUrl: 'templates/static/privacy.html',
                    title: "seo.title.privacy-policy",
                    description: "seo.description.privacy-policy",
                    robots: "NoIndex, NoFollow",
					canonical: "seo.canonical.privacy-policy",
					alternate: "seo.alternate.privacy-policy"
                }).
                when({
                    'es': '/es/preguntas-frecuentes',
                    'ca': '/ca/preguntes-frequents',
                    'en': '/faq'
                }, {
                    name: 'faq',
                    templateUrl: 'templates/static/faq.html',
                    title: "seo.title.faq",
                    description: "seo.description.faq",
                    robots: "Index, Follow",
					canonical: "seo.canonical.faq",
					alternate: "seo.alternate.faq"
                }).
                when({
                    'es': '/es/cookies',
                    'ca': '/ca/cookies',
                    'en': '/cookies'
                }, {
                    name: 'cookies',
                    templateUrl: 'templates/static/cookies.html',
                    title: "seo.title.cookies",
                    description: "seo.description.cookies",
                    robots: "NoIndex, NoFollow",
					canonical: "seo.canonical.cookies",
					alternate: "seo.alternate.cookies",
                }).
                when({
                    'es': '/pedido/:trackingCode',
                    'ca': '/comanda/:trackingCode',
                    'en': '/order/:trackingCode'
                }, {
                    name: 'track-shortlink',
                    templateUrl: 'templates/static/track_package.html',
                    controller: 'TrackPackageController',
                    css: 'pack-tracker',
                    showMenu: false,
                    title: "seo.title.track-your-delivery",
                    description: "seo.description.track-your-delivery",
                    robots: "NoIndex, NoFollow",
					canonical: "seo.canonical.track-your-delivery",
					alternate: "seo.alternate.track-your-delivery",
					extra: "trackingCode"
                }).
                when({
                    'es': '/es/sigue-tu-envio/:trackingCode',
                    'ca': '/ca/segueix-el-teu-enviament/:trackingCode',
                    'en': '/track-your-delivery/:trackingCode'
                }, {
                    name: 'track-package',
                    templateUrl: 'templates/static/track_package.html',
                    controller: 'TrackPackageController',
                    css: 'pack-tracker',
                    showMenu: false,
                    title: "seo.title.track-your-delivery",
                    description: "seo.description.track-your-delivery",
                    robots: "NoIndex, NoFollow",
					canonical: "seo.canonical.track-your-delivery",
					alternate: "seo.alternate.track-your-delivery",
					extra: "trackingCode"
                }).
                when({
                    'es': '/es/oh-vaya',
                    'ca': '/ca/oh-vaja',
                    'en': '/not-found'
                }, {
                    name: 'notfound',
                    templateUrl: 'templates/static/404.html',
                    controller: '404Controller',
                    title: "seo.title.not-found",
                    description: "seo.description.not-found",
                    robots: "NoIndex, NoFollow",
					canonical: "seo.canonical.not-found",
					alternate: "seo.alternate.not-found",
					extra: ""
                }).
                when({
                    'es': '/es/reestablecer-contrasena',
                    'ca': '/ca/reestablir-contrasenya',
                    'en': '/recover-password'
                }, {
                    name: 'recover',
                    templateUrl: 'templates/recover.html',
                    controller: 'RecoverController',
                    title: "seo.title.recover-password",
                    description: "seo.description.recover-password",
                    robots: "NoIndex, NoFollow",
					canonical: "seo.canonical.recover-password",
					alternate: "seo.alternate.recover-password",
					extra: ""
                }).
                when({
                    'es': '/es/activate',
                    'ca': '/ca/activate',
                    'en': '/activate'
                }, {
                    name: 'activate',
                    templateUrl: 'templates/activate.html',
                    controller: 'ActivateController',
					title: "seo.title.activate",
					description: "seo.description.activate",
					robots: "NoIndex, NoFollow",
					canonical: "seo.canonical.activate",
					alternate: "seo.alternate.activate",
					extra: ""
                }).
                when({
                    'es': '/es/',
                    'ca': '/ca/',
                    'en': '/'
                }, {
                    name: 'home',
                    templateUrl: 'templates/homepage.html',
                    controller: 'HomeController',
                    css: 'home',
                    title: "seo.title.home",
                    description: "seo.description.home",
                    robots: "Index, Follow",
					canonical: "seo.canonical.home",
					alternate: "seo.alternate.home",
					extra: ""
                })
                .otherwise({
                    redirectTo: '/404'
                }).install($routeProvider);

            $mdDateLocaleProvider.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
            $mdDateLocaleProvider.shortMonths = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
            $mdDateLocaleProvider.days = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
            $mdDateLocaleProvider.shortDays = ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'];
            $mdDateLocaleProvider.firstDayOfWeek = 1;

            $mdDateLocaleProvider.formatDate = function (date) {
                return moment(date).format('LL');
            };
        })

        .constant('LocaleCfgs', {
            months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            days: ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"],
            shortDays: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]
        })

        .config(function(saRouterProvider, Configuration) {
            saRouterProvider.setDefaultLang(Configuration.defaultLang);
        })

        .config(["$translateProvider", "Configuration", function($translateProvider, Configuration){

                $translateProvider
                    .preferredLanguage(Configuration.defaultLang)
                    .useStaticFilesLoader({
                        prefix: 'languages/',
                        suffix: '.json'
                    });
            }]
        )

        .constant('boundaries', [[41.341247, 2.1224212999999996],
                                [41.328357600000004, 2.1591568],
                                [41.472830699999996,2.2909928],
                                [41.4512187,2.1766662],
                                [41.4064283,2.1172714],
                                [41.36469919999999,2.0860290999999997],
                                [41.341247,2.1224212999999996]])

        .constant('boundariesByZone',
            {
                "BCN": {
                    center: [41.393014, 2.175536],
                    zoom: 15,
                    boundaries: [
                        [41.341247, 2.1224212999999996],
                        [41.328357600000004, 2.1591568],
                        [41.472830699999996, 2.2909928],
                        [41.4512187, 2.1766662],
                        [41.4064283, 2.1172714],
                        [41.36469919999999, 2.0860290999999997],
                        [41.341247, 2.1224212999999996]
                    ]
                },
                "MAD": {
                    center: [40.457726, -3.677142],
                    zoom: 15,
                    boundaries: [
                        [40.630702, -3.423645],
                        [40.204123, -4.104797]
                    ]
                },
                "SCV": {
                    center: [41.4719649, 2.0803055],
                    zoom: 15,
                    boundaries: [
                        [41.444270524199645, 2.0183944702148438],
                        [41.5175751539352, 2.080535888671875]
                    ]
                },
                "SPAIN": {
                    center: [40.414282, -3.703835],
                    zoom: 5,
                    boundaries: [
                        [42.393903, 3.031268],
                        [37.739068, -6.966290]
                    ]
                }
            })

        .config(function (Configuration, AnalyticsProvider) {
            AnalyticsProvider
                .setAccount({
                    tracker: Configuration.gaTrackingID,
                    name: "shargotracker",
                    trackEvent: true
                })
                .setDomainName(Configuration.gaDomainName);
        })

        .filter('displayLang', function() {
            return function(input) {
                var langFormat = input;
                switch(input.toLowerCase()) {
                    case 'ca':
                        langFormat = 'Català';
                        break;
                    case 'es':
                        langFormat = 'Español';
                        break;
                    case 'en':
                        langFormat = 'English';
                        break;
                }
                return langFormat;
            };
        })



		.filter('priceEuro', function() {
			return function(price) {
			    if (!price && price !== 0){
			        return "- - €"
                }
                else {
					return String(parseFloat(Math.round(price * 100) / 100).toFixed(2)).replace('.',',') + "€";
                }
			};
		})

        .constant('AUTH_EVENTS', {
            loginSuccess: 'auth-login-success',
            loginFailed: 'auth-login-failed',
            logoutSuccess: 'auth-logout-success',
            sessionTimeout: 'auth-session-timeout',
            notAuthenticated: 'auth-not-authenticated',
            notAuthorized: 'auth-not-authorized'
        })

        .factory('AuthService', function ($http, Configuration, toolsService) {
            var authService = {};

            authService.login = function (credentials) {
                return $http
                    .post(Configuration.apiUrl + '/auth/signin', credentials)
                    .then(function (res) {
                        localStorage.setItem('userid', res.data._id);
                        localStorage.setItem('xtoken', res.data.authToken);
                        localStorage.setItem('firstName', res.data.firstName);
                        localStorage.setItem('lastName', res.data.lastName);
                        localStorage.setItem('type', res.data.type); //sender | driver
                        return res;
                    });
            };

            authService.isAuthenticated = function () {
                return !toolsService.isEmpty(localStorage.getItem('xtoken')) && !toolsService.isEmpty(localStorage.getItem('userid'));
            };

			authService.isDriver = function () {
				return !toolsService.isEmpty(localStorage.getItem('xtoken')) && !toolsService.isEmpty(localStorage.getItem('userid')) && localStorage.getItem('type') === 'driver';
			};

			authService.isSender = function () {
				return !toolsService.isEmpty(localStorage.getItem('xtoken')) && !toolsService.isEmpty(localStorage.getItem('userid')) && localStorage.getItem('type') === 'sender';
			};

            authService.logout = function () {
				localStorage.clear();
			};

            return authService;
        })

        /*
         status: true,
         cookie: true,
         */

        // Analytics dependency in the run directive allows google tracking
        .run(function($rootScope, $window, Analytics, Configuration) {
            var OneSignal = $window.OneSignal || [];
            OneSignal.push(["init", {
                appId: Configuration.oneSignalAppId,
                autoRegister: false,
                notifyButton: {
                    enable: false /* Set to false to hide */
                },
                safari_web_id: Configuration.oneSignalSafariWebId
            }]);


            $window.fbAsyncInit = function() {
                // hard-coded appid to avoid fb crash on login
                FB.init({
                    appId      : "1612290799020399",
                    xfbml      : true,
                    version    : 'v2.7',
                    status     : true
                });
            };
            (function(d){
                // load the Facebook javascript SDK
                var js,
                    id = 'facebook-jssdk',
                    ref = d.getElementsByTagName('script')[0];

                if (d.getElementById(id)) {
                    return;
                }
                js = d.createElement('script');
                js.id = id;
                js.async = true;
                js.src = "//connect.facebook.net/en_US/sdk.js";
                ref.parentNode.insertBefore(js, ref);
            }(document));

            //console.log("Inicializo Fb Pixel!");
            $window._fbq.push(['addPixelId', Configuration.facebookPixelId]);
            $rootScope.$on('$routeChangeSuccess', function( event, $currentRoute, $previousRoute ) {
                //console.log("Envío push a Fb Pixel $currentRoute -> ", $currentRoute);
                $window._fbq.push(['track', 'ViewContent']);
                //$window._fbq.push(['track', 'ViewContent', {}]); // Custom event
            });
        })

        .controller('ApplicationController', function ($http, $q, $timeout, $scope, AuthService, $location, $window, $rootScope, $cookies, $translate, $mdDateLocale, saRouter, deviceDetector, Configuration, LocaleCfgs, toolsService, MGMService) {
			$rootScope.device = {
				"isDesktop"		: deviceDetector.isDesktop(),
				"isPhone"		: deviceDetector.isMobile() && !deviceDetector.isTablet(),
				"isTablet"		: deviceDetector.isTablet(),
				"os"			: deviceDetector.os,
				"isVertical"	: $window.innerHeight > $window.innerWidth,
				"isHorizontal"	: $window.innerHeight <= $window.innerWidth
			};
			angular.element($window).bind('resize', function () {
				$rootScope.device.isVertical 	= $window.innerHeight > $window.innerWidth;
				$rootScope.device.isHorizontal 	= $window.innerHeight <= $window.innerWidth;
			});
            $rootScope.blur = { default: false };
			$rootScope.pageConfiguration = {
				footer: true,
				header: {
					solid: $window.innerHeight - 115,
					background: 'linear-gradient(to bottom, #fed256, #ffbd4d)',
					preheader: true,
					headerLink: $rootScope.url('home'),
					headerLogo: $rootScope.device.isDesktop ? Configuration.siteDomain + "/img/header/shargo-white.svg" : Configuration.siteDomain + "/img/header/shargo-mobile.svg",
					logIn: true,
					dashboard: true,
					callToAction: {
						link: $rootScope.device.isDesktop ? $rootScope.url('sendpackage') : $rootScope.url('contact'),
						text: $rootScope.device.isDesktop ? 'header.ask4Shargo' : 'header.contact',
						target: '_self',
						hide: true,
						disabled: false
					},
					profile: true
				}
			};
			$rootScope.isUserLogged = AuthService.isAuthenticated();
			$rootScope.pendingRating = false;
			$rootScope.mgm = {
			    show: {}
            };
            $rootScope.Configuration = Configuration;
            $rootScope.toolsService = toolsService;
            $scope.seo = {
                title: "seo.title.home",
                description: "seo.description.home",
                robots: "Index, Follow",
                canonical: "seo.canonical.home",
				extra: "",
                shargoPro: false
            };
            /* MGM */
			$scope.mailMGMFeedback = "";
			$scope.clipboardMGMFeedback = "";
			$rootScope.clipboardTextButton = "";
			$scope.mailsToShareCode = "";
			$scope.mailsToShareCodeError = "";

			$scope.sendMGMMail = function(email) {
				console.log("sendMGMMail -> ",email);
				var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				if (!re.test(email)) {
					$scope.mailsToShareCodeError = "common.error-email";
				}
				else {
					MGMService.sendMGMMail(email).then(function(data) {
						$scope.mailMGMFeedback = "common.promo.mgm.feedback-ok";
					}, function() {
						$scope.mailMGMFeedback = "common.promo.mgm.feedback-ko";
					}).finally(function() {
						$timeout(function() {
							$scope.mailMGMFeedback = "";
						}, 2000);
					});
                }
			};

			$scope.openExternalLink = function(url) {
				url = url.replace(/#/g, "%23");
				$window.open(url,'_blank');
			};

			$scope.clipboardSupported = false;

			$scope.copyToClipboardSuccess = function() {
				$scope.clipboardMGMFeedback = "common.promo.mgm.feedback-clipboard-ok";
				$timeout(function() {
					$scope.clipboardMGMFeedback = "";
				}, 500);
			};

			$scope.copyToClipboardFail = function(err) {
				console.log("copyToClipboardFail -> ", err);
				$scope.clipboardMGMFeedback = "common.promo.mgm.feedback-clipboard-ok";
				$timeout(function() {
					$scope.clipboardMGMFeedback = "";
				}, 2000);
			};

			$scope.cleanShareMsg = function(rawMsg) {
				return encodeURI(rawMsg);
			};
			$scope.hideMGMPopUp = function(type) {
			    if ($rootScope.mgm.show.promotion == "invitation" && $rootScope.blur["MGMPopUp" + type + "Forced"]){
					$rootScope.mgm.show[type] = $rootScope.blur["MGMPopUp" + type] = $rootScope.blur["MGMPopUp" + type + "Forced"];
					$rootScope.blur["MGMPopUp" + type + "Forced"] = false;
					if ($rootScope.mgm.show[type]){
						$rootScope.mgm.show[type] = "invitation";
					}
				}
				else if ($rootScope.mgm.show.promotion == "referral") {
					$rootScope.mgm.show[type] = false;
					++$rootScope.mgm.index;
					if ($rootScope.mgm.index < $rootScope.mgm.list.length) {
						$timeout(function () {
							$rootScope.mgm.show.promotion = "referral"; //"refered" "invitation"
							$rootScope.blur.MGMPopUppromotion = true;
							$rootScope.clipboardTextButton = response.data.referralUrl.substr(response.data.referralUrl.indexOf("shargo.io"));
						}, 250);
					}
					else {
						$rootScope.blur["MGMPopUp" + type] = false;
					}
				}
                else {
					$rootScope.mgm.show[type] = $rootScope.blur["MGMPopUp" + type] = false;
				}
				$scope.mailsToShareCode = "";
				$scope.mailsToShareCodeError = "";
			};
			/////////////////////////////////////////////


            $scope.triggerHeaderCtaHiding = function(inview, firstTime, inviewpart, event) {
                //console.log("triggering hHeader Cta hiding", new Date(), " argument: ", arguments);
                // If user is logged in, cta is always visible
                $rootScope.hideHeaderCta = inview && !AuthService.isAuthenticated();
                $rootScope.headerAnimationFirstTime = firstTime;
                $timeout(function () {
                    if($rootScope.hideHeaderCta) {
                        angular.element(".login-form").css('right', '20px');
                        angular.element(".restablish-form").css('right', '20px');
                        angular.element(".register-form").css('right', '0px');
                    } else {
                        angular.element(".login-form").css('right', '220px');
                        angular.element(".restablish-form").css('right', '220px');
                        angular.element(".register-form").css('right', '200px');
                    }
                },0);
            };

            $scope.headerButton = function () {
                if ($scope.pageKey.name == 'driver-page') {
                    $scope.redirect( $rootScope.url('driver-form') );
                }
                else {
                    $scope.redirect( $rootScope.url('sendpackage') );
                }
            };

            $scope.showMenu = true;
            $scope.toolsService = toolsService;

            $scope.pageCtx = {
                headerUrl: 'header.html'
            };

            $scope.newWindow = function (newUrl) {
                $window.open(newUrl, '_blank');
            };

            function setLanguage(lang) {
                //console.log("setLanguage > arguments: ", arguments);
                //console.log("setLanguage > pageKey: ", $scope.pageKey);
                var pageParams = $scope.pageParams || {};
                pageParams.lang = lang || $scope.defaultLang;

                var oldLang = $scope.selectedLang;
                $scope.selectedLang = pageParams.lang || oldLang;
                $rootScope.lang = $scope.selectedLang;

                //console.log("setLanguage > oldLang; ", oldLang," new: ",$scope.selectedLang);

                if(toolsService.isEmpty($scope.pageKey.name)) {
                    $scope.pageKey.name = 'notfound';
                }
                var currentUrl = $location.path();
                var newUrl = saRouter.routePath($scope.pageKey.name, pageParams);
                //console.log("setLanguage > $scope.selectedLang ->", $scope.selectedLang);
                //console.log("setLanguage > pageParams ->", pageParams, " newUrl: ", newUrl," currentUrl: ", currentUrl);

                if(oldLang != $scope.selectedLang || currentUrl != newUrl) {
                    //console.log("DEBUG setLanguage > IDIOMA CAMBIA, enruto");
                    $cookies.put("shargoLang", $scope.selectedLang);
                    $location.path(newUrl);
                } else {
                    //console.log("DEBUG setLanguage > IDIOMA NO CAMBIA, no enruto");
                }
            }

            // method called from tpl
            $scope.changeLanguage = function(lang) {
                setLanguage(lang);
            };

            $scope.pageKey = {};
            $scope.pageCss = '';
            var browserLang = $window.navigator.language || $window.navigator.userLanguage;
            //console.log("browserLang - >", browserLang, " NAVIGATOR: ", $window.navigator);
            browserLang = (!toolsService.isEmpty(browserLang) && browserLang.length > 2) ? browserLang.substring(0,2).toLowerCase() : browserLang;
            $scope.defaultLang = $cookies.get("shargoLang") || browserLang || Configuration.defaultLang;
            //console.log("DEBUG $cookies.get(shargoLang) -> ",$cookies.get("shargoLang"));
            saRouter.setDefaultLang($scope.defaultLang);
            $scope.selectedLang = $scope.defaultLang;
            //console.log("DEBUG $scope.selectedLang -> ", $scope.selectedLang);

            $scope.redirect = function (url) {
                $location.path(url);
            };

            $scope.deviceDetector = deviceDetector;
            $scope.deviceClass = 'other';
            if($scope.deviceDetector.raw.os.ios) {
                $scope.deviceClass = 'ios';
            } else if($scope.deviceDetector.raw.os.android) {
                $scope.deviceClass = 'android';
            }

            $rootScope.$on('$routeChangeSuccess', function( event, $currentRoute, $previousRoute ) {
				$scope.pageCss = '';
                $scope.customCss = '';
                $scope.pageKey = {};
                $scope.pageParams = {};
                $scope.pageCtx.headerUrl = 'header.html';
                $rootScope.hideHeaderCta = !AuthService.isAuthenticated();
                if(!toolsService.isEmpty($currentRoute) && !toolsService.isEmpty($currentRoute.$$route)){
                    var pageInfo = $currentRoute.$$route;
                    $scope.pageKey = pageInfo || {};
                    $scope.pageParams = $currentRoute.pathParams || {};
                    if(!toolsService.isEmpty(pageInfo.css)) {
                        $scope.customCss = pageInfo.css;
                    }
					if(pageInfo.shargoPro) {
						$scope.pageKey.shargoPro = true;
						if(!toolsService.isEmpty(pageInfo.css)) {
							$scope.customCss = pageInfo.css + " shargopro";
                        }
                        else {
						    $scope.customCss = "shargopro";
                        }
                        $scope.seo.shargoPro = "-shargopro";
					}
					else {
						$scope.seo.shargoPro = "";
					}
                    if(!toolsService.isEmpty(pageInfo.title)){
                        $scope.seo.title = pageInfo.title;
                    }
                    else {
                        $scope.seo.title = "";
                    }
                    if(!toolsService.isEmpty(pageInfo.description)){
                        $scope.seo.description = pageInfo.description;
                    }
                    else {
                        $scope.seo.description = "";
                    }
                    if(!toolsService.isEmpty(pageInfo.robots)){
                        $scope.seo.robots = pageInfo.robots;
                    }
                    else {
                        $scope.seo.robots = "";
                    }
                    if(!toolsService.isEmpty(pageInfo.canonical)){
                        $scope.seo.canonical = pageInfo.canonical;
                    }
                    else {
                        $scope.seo.canonical = "";
                    }
                    if(!toolsService.isEmpty(pageInfo.alternate)){
                        $scope.seo.alternate = {
                            a: pageInfo.alternate  + ".a",
                            b: pageInfo.alternate  + ".b"
                        };
                    }
                    else {
                        $scope.seo.alternate = {
                            a: "",
                            b: ""
                        };
                    }
					if(!toolsService.isEmpty(pageInfo.extra)){
						$scope.seo.extra = $scope.pageParams[pageInfo.extra];
					}
					else {
						$scope.seo.extra = "";
					}
                    if(!toolsService.isEmpty($scope.pageKey.name)) {
                        $scope.pageCss = $scope.pageKey.name;

                        if(AuthService.isAuthenticated()) {
                            $rootScope.hideHeaderCta = false;
                        } else if($scope.pageKey.name != 'home') {
                            $rootScope.hideHeaderCta = false;
                        }

                    }
                    if($scope.pageKey.headerUrl) {
                        $scope.pageCtx.headerUrl = $scope.pageKey.headerUrl;
                    }
                }
                $scope.triggerHeaderCtaHiding($rootScope.hideHeaderCta, true);

                setLanguage($scope.selectedLang);
                $translate.use($scope.selectedLang);



                if ($scope.pageKey.name === 'dashboard') {
                    $rootScope.pendingRating = false;
                }


                waitUntilZendeskLoaded().then(function (response) {
                    if ($scope.pageKey.name === 'dashboard' || $scope.pageKey.name === 'home' || $scope.pageKey.name === 'sendpackage'){
                        angular.element(".zEWidget-launcher").css("display", "block");
                    }
                    else {
                        angular.element(".zEWidget-launcher").css("display", "none");
                    }
                });

                if(AuthService.isDriver()) {
                    $location.path($rootScope.url('driver-profile'));
                }

                if ($scope.pageKey.name === "faq" || $scope.pageKey.name === "termsconditions" || $scope.pageKey.name === "privacy" || $scope.pageKey.name === "terms") {
					$rootScope.pageConfiguration = {
						footer: true,
						header: {
							solid: -1000,
							background: 'linear-gradient(to bottom, #fed256, #ffbd4d)',
							preheader: false,
							headerLink: $rootScope.url('home'),
							headerLogo: $rootScope.device.isDesktop ? Configuration.siteDomain + "/img/header/shargo-white.svg" : Configuration.siteDomain + "/img/header/shargo-mobile.svg",
							logIn: true,
							dashboard: true,
							callToAction: {
								link: $rootScope.device.isDesktop ? $rootScope.url('sendpackage') : $rootScope.url('contact'),
								text: $rootScope.device.isDesktop ? 'header.ask4Shargo' : 'header.contact',
								target: '',
								hide: false,
								disabled: false
							},
							profile: true
						}
					};
                }
            });

            function waitUntilZendeskLoaded() {
                var deferred = $q.defer();
                var checkExist = setInterval(function() {
                    if (angular.element(".zEWidget-launcher").length && angular.element(".zEWidget-launcher")[0] &&
                        angular.element(".zEWidget-launcher")[0].offsetHeight > 0) {
                        clearInterval(checkExist);
                        deferred.resolve();
                    }
                }, 100);
                return deferred.promise;
            }

            $rootScope.$on('$translateChangeSuccess', function () {
                $translate(LocaleCfgs.months).then(function(trans) {
                    var monthTrans = [];
                    Object.keys(trans).forEach(function(key) {
                        monthTrans.push(trans[key]);
                    });
                    $mdDateLocale.months = monthTrans;
                });

                $translate(LocaleCfgs.shortMonths).then(function(trans) {
                    var shortMonthTrans = [];
                    Object.keys(trans).forEach(function(key) {
                        shortMonthTrans.push(trans[key]);
                    });
                    $mdDateLocale.shortMonths = shortMonthTrans;
                });

                $translate(LocaleCfgs.days).then(function(trans) {
                    var dayTrans = [];
                    Object.keys(trans).forEach(function(key) {
                        dayTrans.push(trans[key]);
                    });
                    $mdDateLocale.days = dayTrans;
                });

                $translate(LocaleCfgs.shortDays).then(function(trans) {
                    var shortDayTrans = [];
                    Object.keys(trans).forEach(function(key) {
                        shortDayTrans.push(trans[key]);
                    });
                    $mdDateLocale.shortDays = shortDayTrans;
                });
            });

            var cookiesKey = 'shargoCookiesPolicy';
            $scope.cookiesAreAcceppted = ($cookies.get(cookiesKey) == 'ok');
            $scope.acceptCookies = function() {
                var now = new Date();
                $cookies.put(cookiesKey, 'ok', {
                    expires: new Date(now.getFullYear()+1, now.getMonth(), now.getDate())
                });
                $scope.cookiesAreAcceppted = true;
            };

            // toggle class for hamburguer menu
            $scope.isActive = false;
            $scope.activeButton = function() {
                $scope.isActive = !$scope.isActive;
            };

            $scope.setActive = function(){
                $scope.isActive = !$scope.isActive;
            };
        })
        /*
        .controller('ResponsiveCarousel', ['$scope', function($scope){
            $scope.slides = [
                {
                    image: '/img/cara-dummy.jpg',
                    name: 'Name',
                    title: 'title',
                    testimonial: "Testimonial"
                },
                {
                    image: '/img/cara-dummy.jpg',
                    name: 'Name',
                    title: 'title',
                    testimonial: ""
                },
                {
                    image: '/img/cara-dummy.jpg',
                    name: 'Name',
                    title: 'title',
                    testimonial: "Testimonial"
                },
                {
                    image: '/img/cara-dummy.jpg',
                    name: 'Name',
                    title: 'title',
                    testimonial: ""
                }
            ];
        }])
        */

        .run(function ($rootScope, AUTH_EVENTS, AuthService) {
            $rootScope.$on('$stateChangeStart', function (event, next) {
                event.preventDefault();
                if (!AuthService.isAuthenticated()) {
                    $rootScope.$broadcast(AUTH_EVENTS.notAuthenticated);
                }
            });

        })
        
        .directive('headerShargo', function () {
            return {
                templateUrl: './templates/static/header.html',
                controller: 'HeaderController'
            }
		})

		.directive('footerShargo', function () {
			return {
				templateUrl: './templates/static/footer.html',
				controller: 'FooterController'
			};
		})

        .directive('sendForm', function () {
            return {
                templateUrl: './templates/send-package/send-form.html'
            };
        })

        .directive('sendCheckout', function () {
            return {
                templateUrl: './templates/send-package/send-checkout.html'
            };
        })

        .directive('dashSidebar', function () {
            return {
                templateUrl: './templates/dashboard/sidebar.html'
            };
        })

        .directive('dashBody', function () {
            return {
                templateUrl: './templates/dashboard/body.html'
            };
        })

        .directive('dashEmpty', function () {
            return {
                templateUrl: './templates/dashboard/empty.html'
            };
        })

        .directive('profileSidebar', function () {
            return {
                templateUrl: './templates/profile/sidebar.html'
            };
        })

        .directive('profileBody', function () {
            return {
                templateUrl: './templates/profile/body.html'
            };
        })

        .directive('profileDetails', function () {
            return {
                templateUrl: './templates/profile/profile-details.html'
            };
        })

        .directive('profileEdit', function () {
            return {
                templateUrl: './templates/profile/profile-edit.html'
            };
        })

        .directive('profilePromo', function () {
            return {
                templateUrl: './templates/profile/profile-promo.html'
            };
        })

        .directive('profilePass', function () {
            return {
                templateUrl: './templates/profile/profile-pass.html'
            };
        })

        .directive('scrollOnClick', function () {
            return {
                restrict: 'A',
                link: function ($rootScope, $elm, attrs) {
                    var idToScroll = attrs.href;
                    $elm.on('click', function (e) {
                        e.preventDefault();
                        var $target;
                        if (idToScroll) {
                            $target = $(idToScroll);
                        } else {
                            $target = $elm;
                        }
                        $("body").animate({scrollTop: $target.offset().top}, "slow");
                    });
                }
            }
        })

        .directive('clickOut',  ['$window', '$parse', function ($window, $parse) {
            return {
              restrict: 'A',
              link: function (scope, element, attrs) {
                var clickOutHandler = $parse(attrs.clickOut);

                angular.element($window).on('click', function (event) {
                  if (element[0].contains(event.target)) return;
                  clickOutHandler(scope, {$event: event});
                  scope.$apply();
                });
              }
            };
        }])

        .directive('contenteditable', function() {
            return {
                restrict: 'A', // only activate on element attribute
                require: '?ngModel', // get a hold of NgModelController
                link: function(scope, element, attrs, ngModel) {
                    if(!ngModel || !attrs.contenteditable) return; // do nothing if no ng-model
                    // Specify how UI should be updated
                    ngModel.$render = function() {
                        element.html(ngModel.$viewValue || '');
                    };

                    // Listen for change events to enable binding
                    element.on('blur keyup change', function() {
                        scope.$apply(read);
                    });
                    read(); // initialize

                    // Write data to the model
                    function read() {
                        var html = element.html();
                        // When we clear the content editable the browser leaves a <br> behind
                        // If strip-br attribute is provided then we strip this out
                        if( attrs.stripBr && html == '<br>' ) {
                            html = '';
                        }
                        ngModel.$setViewValue(html);
                    }

                    element.on('keydown', function (event){
                        if(event.which == '13'){
                            return false;
                        }
                    });
                }
            };
        })

        .directive('nextInput', ['$parse', function($parse) {
            return {
                restrict: 'A',
                require: ['ngModel'],
                link: function(scope, element, attrs, ctrls) {
                    var model=ctrls[0], form=ctrls[1];

                    scope.next = function(){
                        return model.$modelValue;
                    };

                    scope.$watch(scope.next, function(newValue, oldValue){
                        if (model.$modelValue.length == attrs.maxlength)
                        {
                            var nextinput = element.parent().next().find('input');
                            if (nextinput.length === 1)
                            {
                                nextinput[0].focus();
                            }
                        }
                    })
                }
            }
        }])

        .directive('fileDropzone', function(){
            return {
                restrict: 'A',
                scope: {
                    file: '=',
                    fileName: '='
                },
                link: function(scope, element, attrs) {
                    var checkSize, isTypeValid, processDragOverOrEnter, processDragLeave, validMimeTypes;
                    processDragLeave = function (event) {
                        scope.hoverDrag = false;
                        $('.image-upload').removeClass('hoverDrag');
                    };
                    processDragOverOrEnter = function(event) {
                        if (event != null) {
                            event.preventDefault();
                        }
                        (event.originalEvent || event).dataTransfer.effectAllowed = 'move';
                        if (!scope.hoverDrag) {
                            scope.hoverDrag = true;
                            $('.image-upload').toggleClass('hoverDrag');
                        }
                        return false;
                    };
                    validMimeTypes = attrs.fileDropzone;
                    checkSize = function(size) {
                        var _ref;
                        if (((_ref = attrs.maxFileSize) === (void 0) || _ref === '') || (size / 1024) / 1024 < attrs.maxFileSize) {
                            return true;
                        } else {
                            alert("File must be smaller than " + attrs.maxFileSize + " MB");
                            return false;
                        }
                    };
                    isTypeValid = function(type) {
                        if ((validMimeTypes === (void 0) || validMimeTypes === '') || validMimeTypes.indexOf(type) > -1) {
                            return true;
                        } else {
                            alert("Invalid file type.  File must be one of following types " + validMimeTypes);
                            return false;
                        }
                    };
                    element.bind('dragover', processDragOverOrEnter);
                    element.bind('dragenter', processDragOverOrEnter);
                    element.bind('dragleave', processDragLeave);
                    return element.bind('drop', function(event) {
                        scope.hoverDrag = false;
                        $('.image-upload').removeClass('hoverDrag');
                        var file, name, reader, size, type;
                        if (event != null) {
                            event.preventDefault();
                        }
                        reader = new FileReader();
                        reader.onload = function(evt) {
                            if (checkSize(size) && isTypeValid(type)) {
                                return scope.$apply(function() {
                                    scope.file = {
                                        base64: evt.target.result,
                                        filetype: type,
                                        filesize: size,
                                        filename: name
                                    };
                                    if (angular.isString(scope.fileName)) {
                                        return scope.fileName = name;
                                    }
                                });
                            }
                        };
                        file = (event.originalEvent || event).dataTransfer.files[0];
                        name = file.name;
                        type = file.type;
                        size = file.size;
                        reader.readAsDataURL(file);
                        return false;
                    });
                }
            };
        })


        // Added decorator as workaround to fix angular-material bug with md-select, as related in: https://github.com/angular/material/issues/5435
        .config(function($provide) {
            $provide.decorator('$mdSelect',['$delegate','$timeout','$interval', function($delegate,$timeout,$interval) {
                var origShow = $delegate.show;
                var stop;
                $delegate.show = function(){
                    var onShow = origShow.apply(this, arguments);
                    onShow.then(function(){
                        $interval.cancel(stop);
                        stop = undefined;
                    });
                    var selectInput = arguments[0].target;
                    var selectDropDown = arguments[0].element;
                    //angular.element(selectDropDown[0]).find('md-select-menu')[0].style.display = 'none';
                    $timeout(function(){
                        var boundings = selectInput.getBoundingClientRect();
                        selectDropDown[0].style.left = boundings.left + "px" ;
                        selectDropDown[0].style.top = (boundings.top + boundings.height) + "px";
                        var dropDownBoundings = selectDropDown[0].getBoundingClientRect();
                        if(dropDownBoundings.width < boundings.width){
                            selectDropDown[0].style.width = boundings.width + "px";
                        }
                        //angular.element(selectDropDown[0]).find('md-select-menu')[0].style.display = '';
                        stop = $interval(function(){
                            selectDropDown[0].style.left = boundings.left + "px" ;
                            selectDropDown[0].style.top = (boundings.top + boundings.height) + "px";
                        },13);
                    },30);
                    return onShow;
                };

                return $delegate;
            }]);
        });

})();
